import { KmsTypeComponent } from "@kaltura/mediaspace-shared-types";
import { ReactElement } from "react";
import { styled } from "@mui/material";
import { Box } from "@kaltura/mediaspace-shared-styled";

type CtaProps = {
    components: KmsTypeComponent[];
    renderComponent: (component: KmsTypeComponent, key?: string) => ReactElement;
    className: string;
    noSidebarTopAndLists: boolean;
};

const StyledCtaContainer = styled(Box)(({ theme }) => ({
    marginBottom: theme.spacing(4),
    marginTop: theme.spacing(-2),
    "&:empty": {
        display: "none",
    },
}));

const CtaContainer = (props: CtaProps) => {
    const { components, renderComponent, className, noSidebarTopAndLists } = props;

    const ctaComponents = components.map((component, index) => {
        component.props = { ...component.props, isEmptyRightPanel: noSidebarTopAndLists, parent: "sidebar" };
        return renderComponent(component, `sidebar-cta-${index}`);
    });

    return <StyledCtaContainer className={className}>{ctaComponents}</StyledCtaContainer>;
};

export default CtaContainer;
